import html2canvas from "html2canvas";
import jsPDF from "jspdf";

/**
 * Renders a DOM node as a single-page (auto-scaled) PDF and downloads it.
 * The capture ignores `.no-print` elements so on-screen filters/buttons stay out.
 */
export async function exportNodeToPdf(node, filename, { orientation = "portrait" } = {}) {
  if (!node) throw new Error("No node to export");
  const canvas = await html2canvas(node, {
    scale: 2,
    backgroundColor: "#ffffff",
    useCORS: true,
    ignoreElements: (el) => el.classList && el.classList.contains("no-print"),
  });
  const imgData = canvas.toDataURL("image/png");
  const pdf = new jsPDF({ orientation, unit: "pt", format: "a4" });
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  // Fit within page while preserving aspect ratio
  const imgW = pageW - 32;
  const imgH = (canvas.height * imgW) / canvas.width;
  let y = 16;
  if (imgH <= pageH - 32) {
    pdf.addImage(imgData, "PNG", 16, y, imgW, imgH);
  } else {
    // Slice into multiple pages
    let remaining = imgH;
    let sy = 0;
    const pageContentH = pageH - 32;
    const ratio = imgW / canvas.width;
    while (remaining > 0) {
      const sliceCanvas = document.createElement("canvas");
      const sliceHpx = Math.min(canvas.height - sy, Math.floor(pageContentH / ratio));
      sliceCanvas.width = canvas.width;
      sliceCanvas.height = sliceHpx;
      const ctx = sliceCanvas.getContext("2d");
      ctx.drawImage(canvas, 0, sy, canvas.width, sliceHpx, 0, 0, canvas.width, sliceHpx);
      const sliceData = sliceCanvas.toDataURL("image/png");
      pdf.addImage(sliceData, "PNG", 16, y, imgW, sliceHpx * ratio);
      remaining -= sliceHpx * ratio;
      sy += sliceHpx;
      if (remaining > 0) { pdf.addPage(); y = 16; }
    }
  }
  pdf.save(filename);
}
